import { connect } from 'react-redux'
import requestMakeUserResponsible from '../../../sagas/requestMakeUserResponsible'
import requestRemoveUser from '../../../sagas/requestRemoveUser'
import User from './User'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  null,
  {
    requestMakeUserResponsible,
    requestRemoveUser
  }
)(User))
